<template>
    <main-layout>
        <div class="registerDiv">
          <div class="container has-text-left">
              <div class="pageTitle">REGISTER</div>
             
            <div class="columns">
              <div class="column">
                  <div class="limitWidth  top40">
                      <form class="form accSettingsForm" v-on:submit.prevent="submitForm" v-if="showForm">
                          <div class="field" :class="{formError: errors.first('fName') }">
                              First Name:*
                              <input type="text" class="input is-warning" name="fName"  v-validate="'required'" v-model="form.fName" />
                              <p class="help is-danger" >
                                  {{ errors.first('fName') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('lName') }">
                              Last Name:*
                              <input type="text" class="input is-warning" name="lName" v-validate="'required'" v-model="form.lName"/>
                              <p class="help is-danger" >
                                  {{ errors.first('lName') }}
                              </p>
                          </div>
                          <div class="field">
                              Company:
                              <input type="text" class="input is-warning" name="Company" v-model="form.company"/>
                          </div>
                          <div class="field" :class="{formError: errors.first('Email') }">
                              Email:*
                              <input type="text" class="input is-warning" name="Email" v-validate="'required|email'" v-model="form.email" />
                              <p class="help is-danger" >
                                  {{ errors.first('Email') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('email2') }">
                              Confirm Email:*
                              <input type="text" class="input is-warning" name="email2" v-validate="{required:true, is: form.email}"  />
                              <p class="help is-danger" >
                                  {{ errors.first('email2') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('City') }">
                              City:*
                              <input type="text" class="input is-warning" name="City" v-validate="'required'" v-model="form.city"/>
                              <p class="help is-danger" >
                                  {{ errors.first('City') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('Country') }">
                              Country:*<br/>
                              <div class="select is-warning width100">
                                  <select name="Country" class="width100"  v-validate="'required'" v-model="form.country">
                                      <option disabled value="">Select...</option>
                                      <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                  </select>
                              </div>
                              <p class="help is-danger" >
                                  {{ errors.first('Country') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('Password') }" >
                              Password:*
                              <input class="input is-warning" type="password" name="Password" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form.password"/>
                              <p class="help is-danger" >
                                  {{ errors.first('Password') }}
                              </p>
                              
                          </div>
                          <div class="field" :class="{formError: errors.first('password2') }">
                              Confirm Password:*
                              <input class="input is-warning" type="password" name="password2" v-validate="{required:true, is: form.password}" />
                              <p class="help is-danger" >
                                  {{ errors.first('password2') }}
                              </p>
                              <span class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</span>
                          </div>
                          <div class="field" :class="{formError: errors.first('terms') }">
                              <label class="checkbox">
                                  <input type="checkbox" name="terms" v-validate="'required'" v-model="form.terms">
                                  *I agree to the <span class="has-text-warning" @click="$router.push('/terms')"><b>terms and conditions</b></span>
                                  <p class="help is-danger" >
                                      {{ errors.first('terms') }}
                                  </p>
                              </label>
      
                          </div>
                          <div class="field">
                              <div id="recaptcha-main" class="g-recaptcha" data-sitekey="6LdPJ7caAAAAABSJZ2-94XxGY_h_7Ux38kc1YfYc"></div>
                          </div>
                          <div class="field">
                              <button id="save" type="submit" class="button is-warning top10">SUBMIT</button>
                          </div>
                      </form>
      
                      <div v-if="!showForm">
                          <div class="is-size-4 has-text-dark">
                              Thank you for registering!
                          </div>
                          <div class="has-text-dark">
                              Please check your email and follow the instructions we sent to verify your account.
                          </div>
      
                          <div class="top20">
                              <button class="button is-warning" @click="login">LOG IN</button>
                          </div>
      
                      </div>
                  </div>
              </div>
              <div class="column">
               <!--  <img src="@/assets/img/regIcon.png" class="top160" width="550" /> -->
              </div>
            </div>
          </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import countries from '../STATIC/countries.js'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
export default {
  components: {
    MainLayout
  },
  data: function () {
    var self = this
    var form = {
      fName: '',
      lName: '',
      company: '',
      email: '',
      country: '',
      city: '',
      password: '',
      terms: false
    }

    return {
      form: form,
      showForm: true,
      countries: countries
    }
  },
  mounted: function(){

    function configRecaptcha(){

    }

    this.$root.loadScript('https://www.google.com/recaptcha/api.js', configRecaptcha)

     setTimeout(() => {
        grecaptcha.render('recaptcha-main'); // 'recaptcha-main' is the id that was assigned to the widget
    }, 200);
  },
  methods: {
    submitForm: function () {
      var self = this

      this.$validator.validateAll().then(res => {
        if (res) {
          doReCaptcha()
        } else {
          self.$root.showModalOK({message: 'Please correct the errors or omissions on the form.'})
        }
      })

      function doReCaptcha(){

         az.addRemSpinner(true, 'id', 'save');
        
          let rc = grecaptcha.getResponse()

         if(rc == '' || rc == undefined){
          self.$root.showModalOK({message: "Please complete the - I'm not a Robot - verification."})
          return
         }
   
            

         function w(d){
           if(d.r == 'ok'){
             doRegistration()
           } else {
             self.$root.showModalOK({message: 'Robot Verification returned an error, please reload the page and try again.'})
           }
         }

         function n(){
           //
         }

         self.$root.apiClient.post('', {token: rc}, w, n)
      }

      function doRegistration () {

            az.addRemSpinner(true, 'id', 'save');
    
                var attributes = [
                  {Name: 'given_name', Value: self.form.fName},
                  {Name: 'family_name', Value: self.form.lName},
                  {Name: 'custom:company', Value: self.form.company},
                  {Name: 'custom:city', Value: self.form.city},
                  {Name: 'custom:countryCode', Value: self.form.country}
                ]
        
                self.$root.azCognito.signUp(self.form.email.toLowerCase(), self.form.password, attributes, signUpCallback)
        
                function signUpCallback (result, obj) {
                  az.addRemSpinner(false, 'id', 'save');
                  if (result == 'error') {
                    if (obj.code == 'UsernameExistsException') {
                      self.$root.showModalOK({message: 'The email you provided is already in use, please login, provide a different email or use the "Forgot Password" function.'})
                    } else {
                      self.$root.showModalOK({message: 'There was an error processing your request. Please try again later or contact support.'})
                    }
                    return
                  }
                  self.showForm = false
                  window.scrollTo(0,0)
                }

        }

    
    },
    login: function () {
      this.$root.showModalLogin({})
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Register.vue